import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { BlockType } from "../type/block-type";
import { ProcessingType } from "../type/processing-type";
import { AbstractApiService } from "./abstract-api-service";

@Injectable({
  providedIn: 'root'
})
export class CommonBlockService extends AbstractApiService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  /**
   * Variables
   */
  get prefix(): string {
    return "common-blocks";
  }

  /**
   * 유형 및 상태에 따른 차단 알림 목록 조회
   * @param params
   * @returns 
   */
  public findAll(params: HttpParams): Observable<any> {
    return this.get('', { params: params }).pipe();
  }

  /**
   * 문서유출 수량 조회
   * @returns 
   */
  public countByExternalAccess(): Observable<any> {
    return this.get('count/external-access').pipe();
  }

  /**
   * 차단이력 서머리 조회
   * @param monitoringType
   * @returns 
   */
   public findSummary(): Observable<any> {
    const url = `${environment.url.api}/statistics/common-blocks`;
    return this.http.get(url).pipe();
  }
}
